export default (query, resolve) =>
  fetch('https://graphql.datocms.com/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer e5fb2baa099b327075e5e7afcb7729`,
    },
    body: JSON.stringify({
      query: `{${query}}`,
    }),
  })
    .then(res => res.json())
    .then(({ data }) => (resolve ? resolve(data) : data))
    .catch(error => (resolve ? resolve(error) : error))
